import { message } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import apiCall from "../../../components/Api";
import StatusComponent from "../../../components/Common/StatusComponent";
import { MarketersBreadcrumbsList, navBarData } from "../Const";
import MasterListLayout from "../MasterListLayout";
import { usePaginatedList } from "../MedicineList/utils";

const MarketersList = () => {
  const navigate = useNavigate();
  const [deleteModal, setDeleteModal] = useState({ id: "", status: false });
  const [loader, setLoader] = useState(true);

  const {
    records,
    count,
    pages,
    skip,
    limit,
    setLimit,
    handlePageChange,
    handleSortClick,
    debouncedSearch,
    list_api_call,
  } = usePaginatedList({ endpoint: "marketers/list" });

  const handleAdd = () => {
    navigate("/healthsy-services/order-medicines/masters/marketers-form");
  };

  const handleEdit = (id) => {
    navigate(
      `/healthsy-services/order-medicines/masters/marketers-form-edit/${id}`,
    );
  };

  const handleClose = () => {
    setDeleteModal({ id: "", status: false });
  };

  const handleDelete = async (id) => {
    try {
      await apiCall(`marketers/delete/${id}`, "DELETE", null, null);
      list_api_call();
      setDeleteModal({ id: "", status: false });
      message.success("Item deleted successfully");
    } catch (error) {
      setDeleteModal({ id: "", status: false });
      message.error("Failed to delete item");
    }
  };

  const handleActive = async (id, status) => {
    try {
      await apiCall(
        `marketers/update/${id}`,
        "PATCH",
        { active: !status },
        null,
      );
      list_api_call();
      message.success("Status updated successfully");
    } catch (error) {
      message.error("Failed to update status");
    }
  };

  const columns = [
    {
      title: "S.No",
      render: (text, record, index) => Number(skip || 0) + (index + 1),
      dataIndex: "serial",
      key: "serial",
      width: 80,
    },
    {
      title: "Status & Actions",
      render: (text, record) => (
        <StatusComponent
          text={text}
          record={record}
          // showPopup={showPopup}
          // setShowPopup={setShowPopup}
          handleEdit={handleEdit}
          setDeleteModal={setDeleteModal}
          handleActive={handleActive}
          title={"marketers"}
        />
      ),
      key: "actions",
      width: 170,
    },
    {
      title: "marketers",
      dataIndex: "marketers",
      key: "marketers",
      width: 200,
      render: (text, record) => (
        <span className="">{record.marketers_name}</span>
      ),
    },
  ];

  useEffect(() => {
    records.length > 0 && setTimeout(() => setLoader(false));
  }, [records]);

  return (
    <MasterListLayout
      title="marketers"
      breadcrumbsList={MarketersBreadcrumbsList("list")}
      onAdd={handleAdd}
      uploadApi="marketers/create-bulk"
      columns={columns}
      records={records}
      count={count}
      pages={pages}
      skip={skip}
      limit={limit}
      handlePageChange={handlePageChange}
      handleDelete={handleDelete}
      deleteModal={deleteModal}
      setDeleteModal={setDeleteModal}
      handleClose={handleClose}
      setLimit={setLimit}
      handleSortClick={handleSortClick}
      onChangeSearch={debouncedSearch}
      navBarData={navBarData}
      loader={loader}
    />
  );
};

export default MarketersList;
